import React from 'react';
import ReactDOM from 'react-dom/client'; 
import './styles/global.css';
import App from './App'; 
import { AuthProvider } from './middleware/AuthContext';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <AuthProvider> 
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}
